module.exports = __webpack_public_path__ + "static/media/tiramasu.290702f5.jpg";